/** `/mix` 総合カタログのみが持つ追加情報。有無がマウント種別の判別子になる。 */
export type MixRuntimeConfig = Readonly<{
  /** ラインナップ順で絞った登録済み総合カタログ対象slug。先頭がアンカー板(=boardKey)。 */
  registeredSlugs: readonly string[];
  /**
   * 登録板のslug→板名。mix内スレページのタイトル/OGP表示に使う。
   * 旧配信HTMLとの互換のため省略可。欠落slugは表示側でslug文字列へ縮退する。
   */
  boardNames?: Readonly<Record<string, string>>;
  boardPresentations?: Readonly<Record<string, BoardPresentation>>;
  boardDefaultDisplayNames?: Readonly<Record<string, string | null>>;
}>;

export type BoardRuntimeConfig = Readonly<{
  boardName: string;
  boardKey: string;
  publicBasePath: string;
  apiBaseUrl: string;
  /** Older injected HTML may omit the board's R18 posting permission. */
  allowR18ThreadCreation?: boolean;
  /** Old injected HTML may omit this field. */
  defaultDisplayName?: string | null;
  mix?: MixRuntimeConfig;
}>;

export type BoardResourceUrls = Readonly<{
  apiBase: string;
  uploadsBase: string;
}>;

/** Return the root API and upload URLs for one initialized board. */
export function getBoardResourceUrls(
  config: BoardRuntimeConfig,
): BoardResourceUrls {
  return {
    apiBase: config.apiBaseUrl,
    uploadsBase: appendUrlPath(config.apiBaseUrl, "/uploads"),
  };
}

/** Prefix an application path with the initialized board's public path. */
export function getBoardPublicPath(
  config: BoardRuntimeConfig,
  pathname: string,
): string {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return normalizedPath === "/"
    ? `${config.publicBasePath}/`
    : `${config.publicBasePath}${normalizedPath}`;
}

function appendUrlPath(baseUrl: string, pathname: string): string {
  if (baseUrl === "") return pathname;
  return `${baseUrl.replace(/\/+$/, "")}/${pathname.replace(/^\/+/, "")}`;
}

import type { BoardPresentation } from "@/config/boardPresentation";
